/**
 * src/utils/csvParser.js
 * Investing.com形式のCSVを解析する共通ユーティリティ
 */

/**
 * src/utils/csvParser.js
 * 【グローバル対応版：タイムゾーンに依存しない日付パース】
 */

export const parseInvestingCSV = (csvText) => {
    const lines = csvText.split(/\r?\n/);
    if (lines.length < 2) return [];

    const rawHeaders = lines[0].replace(/^\uFEFF/, '').split(',').map(h => h.replace(/"/g, '').trim());
    const headerMap = {
        "Date": "Date", "日付け": "Date", "日付": "Date",
        "Price": "Price", "終値": "Price",
        "Open": "Open", "始値": "Open",
        "High": "High", "高値": "High",
        "Low": "Low", "安値": "Low"
    };

    const headers = rawHeaders.map(h => headerMap[h] || h);
    const data = [];

    for (let i = 1; i < lines.length; i++) {
        const line = lines[i].trim();
        if (!line) continue;

        const values = line.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g) || [];
        const entry = {};

        headers.forEach((header, index) => {
            let val = values[index] ? values[index].replace(/"/g, '').trim() : '';
            if (['Price', 'Open', 'High', 'Low'].includes(header)) {
                val = parseFloat(val.replace(/,/g, ''));
            }
            entry[header] = val;
        });

        if (entry['Date']) {
            // 全てのスラッシュ・ハイフン形式を YYYY/MM/DD に統一
            const cleanDate = entry['Date'].replace(/年|月/g, '/').replace(/日/g, '').replace(/-/g, '/');
            const d = new Date(cleanDate);
            
            if (!isNaN(d.getTime())) {
                // 時刻を 00:00:00 に固定したタイムスタンプを保存
                const midnightTs = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
                entry.timestamp = midnightTs;
                entry.dateString = d.getFullYear() + "-" + (d.getMonth()+1).toString().padStart(2,'0') + "-" + d.getDate().toString().padStart(2,'0');
                data.push(entry);
            }
        }
    }
    return data.sort((a, b) => a.timestamp - b.timestamp);
};